export default __webpack_public_path__ + "static/app-features-5--mobile-257e8a9115b6360bbfa5f8aa0eb06394.webp";